// services/loginAPI.js - FIXED storage
import axios from 'axios';
const API_BASE_URL = "https://alcobrakeadmin.com/v3/us";

export const loginAPI = {
  getDealerDetails: async (dealerId) => {
    const response = await fetch(`${API_BASE_URL}/cadealers/getuniquedealer?dealerId=${encodeURIComponent(dealerId)}`);
    if (!response.ok) throw new Error(`Unable to load dealer details (${response.status})`);
    const data = await response.json();
    return data && data[0] ? data[0] : null;
  },

  updateDealerLogo: async (user, file) => {
    const formData = new FormData();
    formData.append('dealerId', user.dealerId);
    formData.append('dealerName', user.userName);
    formData.append('file', file);

    const uploadResponse = await fetch(`${API_BASE_URL}/cadealers/updatedealerlogo`, {
      method: 'POST',
      body: formData,
    });

    if (!uploadResponse.ok) {
      throw new Error(`Logo upload failed (${uploadResponse.status})`);
    }

    const loginUrl = `${API_BASE_URL}/calogin/getuniquelogin?emailId=${encodeURIComponent(user.emailId)}&password=${encodeURIComponent(user.password)}`;
    const loginResponse = await fetch(loginUrl);
    if (!loginResponse.ok) {
      throw new Error(`Unable to refresh dealer details (${loginResponse.status})`);
    }

    const data = await loginResponse.json();
    const updatedUser = data && data[0];
    if (!updatedUser) throw new Error('Updated dealer details were not returned');

    localStorage.setItem('admin_user', JSON.stringify(updatedUser));
    return updatedUser;
  },

  // Login - GET request matching Vue component
  login: async (email, password) => {
    const url = `${API_BASE_URL}/calogin/getuniquelogin?emailId=${encodeURIComponent(email)}&password=${encodeURIComponent(password)}`;
    console.log("Login URL:", url);
    
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      const data = await response.json();
      console.log("Login response:", data);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      // Check if user exists (matching Vue logic)
      const userInfo = data[0];
      if (userInfo) {
        // Store user data exactly like Vue does
        localStorage.setItem("admin_user", JSON.stringify(userInfo));
        localStorage.setItem("isLoggedIn", "true");
        localStorage.setItem("loginTimestamp", Date.now().toString());
        localStorage.setItem("alcobrakeadminreloader", "false");
        localStorage.setItem("isDrivesync", "false");
        
        console.log("User stored successfully:", userInfo);
        
        return { ok: true, userdata: userInfo };
      } else {
        throw new Error("Invalid email or password");
      }
    } catch (error) {
      console.error("Login error:", error);
      throw error;
    }
  },

  // Parent Login
  parentLogin: async (studentId, parentMobile) => {
    const url = `${API_BASE_URL}/app/login/onparentlogin`;
    const info = {
      studentId: studentId,
      parentMobile: parentMobile
    };
    
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(info),
      });
      
      const data = await response.json();
      console.log("Parent login response:", data);
      
      if (data !== "user not found" && data[0]) {
        localStorage.setItem("alcotrackerparentuser", JSON.stringify(data[0]));
        localStorage.setItem("isLoggedIn", "true");
        localStorage.setItem("loginTimestamp", Date.now().toString());
        return { ok: true, studData: data[0] };
      } else {
        throw new Error("User not found");
      }
    } catch (error) {
      console.error("Parent login error:", error);
      throw error;
    }
  },

  // Fleet Login
  fleetLogin: async (email, password) => {
    const url = `${API_BASE_URL}/calogin/getuniquelogin?emailId=${encodeURIComponent(email)}&password=${encodeURIComponent(password)}`;
    console.log("Fleet login URL:", url);
    
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      const data = await response.json();
      console.log("Fleet login response:", data);
      
      const userInfo = data[0];
      if (userInfo) {
        localStorage.setItem("fleetuser", JSON.stringify(userInfo));
        localStorage.setItem("isLoggedIn", "true");
        localStorage.setItem("loginTimestamp", Date.now().toString());
        localStorage.setItem("alcobrakeadminfleetreloader", "false");
        return { ok: true, userdata: userInfo };
      } else {
        throw new Error("Invalid email or password");
      }
    } catch (error) {
      console.error("Fleet login error:", error);
      throw error;
    }
  },

  // Aargee Login
  aargeeLogin: async (email, password) => {
    const url = `${API_BASE_URL}/calogin/getuniquelogin?emailId=${encodeURIComponent(email)}&password=${encodeURIComponent(password)}`;
    
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      const data = await response.json();
      console.log("Aargee login response:", data);
      
      const userInfo = data[0];
      if (userInfo) {
        localStorage.setItem("aargeeuser", JSON.stringify(userInfo));
        localStorage.setItem("isLoggedIn", "true");
        localStorage.setItem("loginTimestamp", Date.now().toString());
        localStorage.setItem("alcobrakeadminaargeereloader", "false");
        return { ok: true, userdata: userInfo };
      } else {
        throw new Error("Invalid email or password");
      }
    } catch (error) {
      console.error("Aargee login error:", error);
      throw error;
    }
  },

  // Get user by email and mobile (Forgot Password)
  getUserByEmailAndMobile: async (dealerEmail, dealerMobile) => {
    const url = `${API_BASE_URL}/cadealers/getuniquedealermobile?dealeremail=${encodeURIComponent(dealerEmail)}&dealermobile=${encodeURIComponent(dealerMobile)}`;
    console.log("Get user URL:", url);
    
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      const data = await response.json();
      console.log("Get user response:", data);
      
      if (response.ok && data && data.length > 0) {
        return data;
      } else {
        throw new Error('No user found with these credentials');
      }
    } catch (error) {
      console.error("Get user error:", error);
      throw error;
    }
  },

  // Change/Reset Password
  changePassword: async (dealerEmail, dealerPassword, confirmPassword, type = 'dealer') => {
    const url = `${API_BASE_URL}/cadealers/editdealerpassword`;
    console.log("Change password URL:", url);
    
    const formData = new FormData();
    formData.append("dealerEmail", dealerEmail);
    formData.append("dealerPassword", dealerPassword);
    formData.append("confirmPassword", confirmPassword);
    formData.append("type", type);
    
    try {
      const response = await axios.post(url, formData);
      console.log("Change password response:", response.status, response.data);
      return response.data;
    } catch (error) {
      console.error("Change password error:", error);
      throw new Error(error.response?.data?.message || error.response?.data || error.message || 'Failed to update password');
    }
  },

  // Logout - clears all storage
  logout: () => {
    localStorage.clear();
  },

  // Get current user
  getCurrentUser: () => {
    const userStr = localStorage.getItem("admin_user");
    if (userStr) {
      try {
        return JSON.parse(userStr);
      } catch (e) {
        return null;
      }
    }
    return null;
  },

  // Get fleet user
  getFleetUser: () => {
    const userStr = localStorage.getItem("fleetuser");
    if (userStr) {
      try {
        return JSON.parse(userStr);
      } catch (e) {
        return null;
      }
    }
    return null;
  },

  // Get parent user
  getParentUser: () => {
    const userStr = localStorage.getItem("alcotrackerparentuser");
    if (userStr) {
      try {
        return JSON.parse(userStr);
      } catch (e) {
        return null;
      }
    }
    return null;
  },

  // Get aargee user
  getAargeeUser: () => {
    const userStr = localStorage.getItem("aargeeuser");
    if (userStr) {
      try {
        return JSON.parse(userStr);
      } catch (e) {
        return null;
      }
    }
    return null;
  },

  // Check login status
  isLoggedIn: () => {
    return localStorage.getItem("admin_user") !== null || 
           localStorage.getItem("fleetuser") !== null ||
           localStorage.getItem("alcotrackerparentuser") !== null ||
           localStorage.getItem("aargeeuser") !== null;
  }
};
